import React from 'react'
import View from '../../../../components/pdf/View'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Separator from '../../../../components/pdf/Separator'
import LabelValue from '../replies/components/LabelValue'

export default function SumNoiseBlockQuestions({ block, replies }) {
  const allowedNoiseBlockQuestions = [
    179043, 176334, 179557, 179991, 180137, 180323, 180797, 181349, 181823, 181073, 182117, 182591, 183025, 183685,
    184159, 184489, 184964, 185398, 185566, 185896, 186370, 186844, 187138, 187432, 189072, 183211
  ]

  if (!allowedNoiseBlockQuestions.includes(block.questionId)) return false

  const format = value => {
    if (typeof value !== 'number') return ''
    return parseFloat(value?.toFixed(2))
  }

  const calcValues = () => {
    const resultado = replies.reduce(
      (acc, replies) => {
        const nps = replies.find(b => b?.question?.name === 'NPS dB(A)')?.value
        const tempo = replies.find(b => b?.question?.name === 'Tempo de exposição (min)')?.value
        const nrrsf = replies.find(b => b?.question?.name === 'NRRSf (dB)')?.value ?? 0
        const tnS = (0.16 * 100) / Math.pow(10, (nps - 80) / 16.61)
        const cnS = tempo / 60
        const doseS = cnS / tnS
        const tnC = (0.16 * 100) / Math.pow(10, (nps - nrrsf - 80) / 16.61)

        const cnC = cnS
        const doseC = cnC / tnC
        return {
          nps: acc.nps + nps,
          tempo: acc.tempo + tempo,
          doseS: acc.doseS + doseS,
          doseC: acc.doseC + doseC
        }
      },
      {
        nps: 0,
        tempo: 0,
        doseS: 0,
        doseC: 0
      }
    )

    const doseAc = resultado.doseS * 100
    const tempo = resultado.tempo / 60
    const doseAt = resultado.doseC * 100
    return {
      tempo,
      doseAc,
      lavg: 80 + 16.61 * Math.log10((0.16 * (doseAc / 100) * 100) / tempo),
      doseAt,
      lavgA: 80 + 16.61 * Math.log10((0.16 * (doseAt / 100) * 100) / tempo)
    }
  }

  const valores = calcValues()

  const calcularConclusao = valores => {
    if (valores.lavg <= 79.99) return 'ABAIXO DO LIMITE DE TOLERÂNCIA'
    if (valores.lavg <= 84.99) return 'NÍVEL DE AÇÃO'
    if (valores.lavg >= 84.99) return 'ACIMA DO LIMITE DE TOLERÂNCIA'
  }

  return (
    <View align="end">
      <Grid align="end" direction={'column'}>
        <Col width={'100%'} flex={1}>
          <LabelValue label={'RESULTADOS DA MEDIÇÃO'} value={''} />
          <LabelValue label={'TEMPO TOTAL (H)'} value={`${format(valores.tempo)} horas`} />
          <LabelValue label={'DOSE ACUMULADA'} value={`${format(valores.doseAc)} %`} />
          <LabelValue label={'LAVG (dB(A))'} value={`${format(valores.lavg)} dB(A)`} />
          <LabelValue label={'DOSE ATENUADA'} value={`${format(valores.doseAt)} %`} />
          <LabelValue label={'LAVG Atenuado (dB(A))'} value={`${format(valores.lavgA)} dB(A)`} />
          <LabelValue label={'CONCLUSÃO'} value={`${calcularConclusao(valores)}`} />
        </Col>
      </Grid>
      <Separator weight={4} />
    </View>
  )
}
